import { ApiResponse } from '@/types';
import api from './client';

// Users API
export const usersAPI = {
  list: async (): Promise<ApiResponse<Array<{ id: string; name: string; role: string }>>> => {
    const response = await api.get('/users');
    return response.data;
  },
  getAll: async (): Promise<ApiResponse<Array<{ id: string; name: string; email: string; role: string; createdAt: string; updatedAt: string; workspaceIds?: string[] }>>> => {
    const response = await api.get('/users');
    return response.data;
  },
  getById: async (id: string): Promise<ApiResponse<{ id: string; name: string; email: string; role: string; createdAt: string; updatedAt: string }>> => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },
  create: async (data: { email: string; name: string; role: string; password: string; playerId?: string; workspaceIds?: string[] }): Promise<ApiResponse<{ id: string; name: string; email: string; role: string; createdAt: string; updatedAt: string }>> => {
    const response = await api.post('/users', data);
    return response.data;
  },
  update: async (id: string, data: { name: string; role: string }): Promise<ApiResponse<{ id: string; name: string; email: string; role: string; createdAt: string; updatedAt: string }>> => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },
  updatePassword: async (id: string, data: { password: string }): Promise<void> => {
    await api.put(`/users/${id}/password`, data);
  },
  delete: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },
  setWorkspaces: async (id: string, workspaceIds: string[]): Promise<void> => {
    await api.put(`/users/${id}/workspaces`, { workspaceIds });
  },
  impersonate: async (id: string): Promise<{ token: string; user: any; workspaces: any[] }> => {
    const response = await api.post(`/users/${id}/impersonate`);
    return response.data;
  },
};
